import { DayType } from '@urbanx/agx.campaigns.client';
import { DropdownOption } from '@urbanx/agx.ui-components2';

export const BusinessDaysOptions: DropdownOption[] = [
  { label: 'day(s)', value: DayType.Days },
  { label: 'business day(s)', value: DayType.BusinessDays },
];
